import apiClient from "./api";

const HISTORIAL_API_BASE_URL = "/historial";

class HistorialService {

    async getHistorialPagos(idSolicitud) {
        try {
            const response = await apiClient.get(`${HISTORIAL_API_BASE_URL}/pagos/${idSolicitud}`);
            if (response.data && response.data.estatus === "OK") {
                return response.data.historial || [];
            }
        } catch (error) {
            console.warn("Error consultando historial de pagos en backend:", error);
        }
        return [];
    }

    async registrarPago(datos) {
        try {
            const response = await apiClient.post(`${HISTORIAL_API_BASE_URL}/pagos`, datos);
            return response.data;
        } catch (error) {
            console.warn("Error registrando historial de pago en backend:", error);
            return { estatus: "ERROR", mensaje: String(error) };
        }
    }

    async getHistorialEventos(idSolicitud) {
        try {
            const response = await apiClient.get(`${HISTORIAL_API_BASE_URL}/eventos/${idSolicitud}`);
            if (response.data && response.data.estatus === "OK") {
                return response.data.historial || [];
            }
        } catch (error) {
            console.warn("Error consultando historial de eventos en backend:", error);
        }
        return [];
    }

    async registrarEvento(datos) {
        try {
            const response = await apiClient.post(`${HISTORIAL_API_BASE_URL}/eventos`, datos);
            return response.data;
        } catch (error) {
            console.warn("Error registrando historial de evento en backend:", error);
            return { estatus: "ERROR", mensaje: String(error) };
        }
    }

}

export default new HistorialService();